import { AnimationOptions } from 'ngx-lottie';

const options: AnimationOptions[] = [
  {
    path: '/assets/ciseaux.json',
  },
  {
    path: '/assets/coeur.json',
  },
  {
    path: '/assets/ensemble.json',
  },
];

export function getAnimations(): AnimationOptions {
  return options[Math.floor(Math.random() * options.length)];
}
